import { defineStore } from 'pinia';
import { reactive, ref, watch } from 'vue';
import { useAtomicSetter } from '@/composables/useAtomicSetter.js';
import { AgencyIdentifierPerPage } from '@/constants/agencies.js';

const useIdentifierStore = defineStore('identifiers', () => {
  const filters = reactive({
    search_text: '',
    sort_by: 'created_at',
    sort_order: 'desc',
    page: 1,
    per_page: AgencyIdentifierPerPage,
  });

  const shouldResetFilters = ref(true);

  const stateRefs = {
    shouldResetFilters,
  };

  const { setAtomic } = useAtomicSetter(stateRefs);

  const setFilters = (newFilters) => {
    Object.assign(filters, newFilters);
  };

  const resetFilters = () => {
    Object.assign(filters, { page: 1, search_text: '' });
  };

  watch(
    () => filters.search_text,
    (newSearchText, oldSearchText) => {
      if (newSearchText !== oldSearchText) {
        setFilters({ page: 1 });
      }
    }
  );

  return { filters, setFilters, resetFilters, ...stateRefs, setAtomic };
});

export { useIdentifierStore };
